import Role from '@/Role.js'
import documents from '@/services/api/documents'
import eventBus, { showConfirmationMenu, showToastError, showToastSuccess } from './event-bus.js'
import signatureChains from './services/api/signatureChains.js'
import users from './services/api/users.js'
import store from './store.js'
import CommonError from './views/CommonError.js'
import SignatureChainListStatus from './views/signature/chains/SignatureChainListStatus.js'
import SignatureChainStatus from './views/signature/chains/SignatureChainStatus.js'
import SignatureChainType from './views/signature/chains/SignatureChainType.js'

export default {
  methods: {
    canUserDeleteChain(chain) {
      const isCreated = chain.status === SignatureChainStatus.CREATED
      const withdrawInstead = this.canWithdraw(chain)
      const res = !isCreated && !withdrawInstead
      return res
    },

    canWithdraw(chain) {
      return chain.status === SignatureChainStatus.CREATED && store.state.currentUser.id === chain.createdBy?.id
    },

    isUserChainOwner(createdBy) {
      return store.state.currentUser.id === createdBy
    },

    hasRoleInternal(role) {
      return store.state.currentUser && store.state.currentUser.roles.includes(role)
    },

    async deleteSignatureChain(item, e, callback) {
      const conf = await showConfirmationMenu({ title: this.$t('dialog.confirmation.title'), posX: e.clientX, posY: e.clientY })
      if (!conf) {
        return
      }

      try {
        await signatureChains.softDeleteSignatureChain(item.id)
        showToastSuccess(this.$t('toastMessage.succesfullyDeleted'))
      } catch (error) {
        let errorMsg = this.$t('toastMessage.errorWhileRetrievingData')
        if ((error.response !== undefined) && (error.response.data.code !== undefined)) {
          const splittedErrorMessage = error.response.data.message.split(' ')

          if (error.response.data.message === 'SignatureChain is not completed') {
            errorMsg = this.$t('toastMessage.notCompleted')
          } else {
            if (error.response.data.code === CommonError.STILL_REFERENCED) {
              errorMsg = this.$t('toastMessage.stillReferenced', { 0: splittedErrorMessage[0], 1: splittedErrorMessage[5] })
            } else {
              errorMsg = this.getErrorMessage(error)
            }
          }
        } else {
          errorMsg = this.getErrorMessage(error)
        }
        showToastError(errorMsg)
      }
      callback()
    },
    async withdrawSignatureChain(id, e, callback) {
      const conf = await showConfirmationMenu({ title: this.$t('dialog.confirmation.title'), posX: e.clientX, posY: e.clientY })
      if (!conf) {
        return
      }

      try {
        await signatureChains.withdrawSignatureChain(id)
        showToastSuccess(this.$t('toastMessage.succesfullyWithdrawn'))
      } catch (error) {
        showToastError(this.getErrorMessage(error))
      }
      callback()
    }

  }
}
